// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all Scholarships
export const viewScholarship = createAsyncThunk(
  "scholarships",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/scholarships`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  }
);

// List only approved Scholarships
export const approvedScholarshipList = createAsyncThunk(
  "scholarships",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/paginate-scholarship`
      );
      // console.log("response : ", response);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  }
);

// Add new Scholarship
export const registerScholarship = createAsyncThunk(
  "scholarships",
  async (scholarshipData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}born-to-win-api/scholarships`,
        scholarshipData
      );
      // console.log("response : ", response);
      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Search Scholarship by ID
export const singleScholarship = createAsyncThunk(
  "scholarships",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/scholarships/${id}`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search scholarship ...");
    }
  }
);

// Update Scholarship
export const updateScholarship = createAsyncThunk(
  "scholarships",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}born-to-win-api/scholarships/${id}`,
        formData
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Delete Scholarship
export const deleteScholarship = createAsyncThunk(
  "scholarships",
  async (id, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.delete(
        `${BaseUrl}born-to-win-api/scholarships/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return handleApiResponse(response, thunkAPI, "Delete successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Single User Scholarships
export const singleUserScholarship = createAsyncThunk(
  "scholarships",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/users-scholarship/${id}`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search scholarship history...");
    }
  }
);

// Approve Scholarship
export const approveScholarship = createAsyncThunk(
  "scholarships",
  async (scholarshipData, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.put(
        `${BaseUrl}born-to-win-api/scholarship-approve/${scholarshipData.id}`,
        scholarshipData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return handleApiResponse(response, thunkAPI, "Approved successfully!");
    } catch (e) {
      return handleApiError(
        e,
        thunkAPI,
        "Please try again. Invalid credentials"
      );
    }
  }
);
